import { render } from "./CheckBox.vue?vue&type=template&id=17dcd7fa&scoped=true&ts=true&lang=html"
import script from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./CheckBox.vue?vue&type=style&index=0&id=17dcd7fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dcd7fa"]])

export default __exports__